module.exports = __webpack_public_path__ + "img/logo-Plural2.fc54cb36.png";